import { Component, EventEmitter, Input, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { FirestoreService } from '../firestore-service.service';
import { Comment, url } from '../container';
import { collection, query, where, onSnapshot} from "firebase/firestore";
import { getStorage, ref as refStorage, getDownloadURL } from "firebase/storage"
import { SharedServiceService } from '../shared-service.service';
import { NgxEditorModule } from 'ngx-editor';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AddcommentComponent } from '../addcomment/addcomment.component';
import { ShowcommentComponent } from '../showcomment/showcomment.component';
//import { K } from '@angular/cdk/keycodes';
//import { ActivatedRoute } from '@angular/router';


@Component({
    selector: 'app-discussionchannellazy',
    templateUrl: './discussionchannellazy.component.html',
    styleUrl: './discussionchannellazy.component.scss',
    standalone: true,
    imports: [CommonModule, 
      FormsModule, 
      NgxEditorModule,
      AddcommentComponent,
      ShowcommentComponent,
    ],
})
export class DiscussionchannellazyComponent implements OnDestroy {
  @Input() organizationKey: string = "";
  @Input() projectKey: string = "";
  @Input() projectName: string = "";
  @Input() userId: string = "";
  @Input() channelKey: string = ""
  @Input() channelName: string = "";
  @Input() channelPath: string = "";
  @Input() userDisplayName: string = "";
  @Input() contentType: string = "";
  @Input() doAddCover: boolean = true;
  @Input() userImageURL = ""
  @Input() embeddingModel: string = ""
  @Output() commentUpdated = new EventEmitter<{comments: Comment[]}>();
  isAddCommentEditorPresent: boolean = true
  comments: Comment[] = [];
  isLoadingLabelVisible: boolean = true
  unsubscribeComments: any
  editedCommentKey: string = "" // if user clicked comment to edit the variable contains its key
  pathSegments: string[] = []


  constructor(private firestoreDb: FirestoreService, public service: SharedServiceService) {
    if (!this.channelKey) {
      this.channelKey = "mainChannel"
      this.channelPath = "https://wroolo.com/channels/"+this.channelKey
      this.channelName = "Main"
    }
  }

  ngOnInit() { }

  ngAfterViewInit() {
  }

  ngAfterContentInit() {
    this.startListeningToComments(this.channelKey)
  }

  ngDoCheck() {}

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes["channelKey"])&&(!changes["channelKey"].firstChange)) {
      let channelKey = changes["channelKey"].currentValue
      this.startListeningToComments(channelKey)
    }
  }

  ngOnDestroy() {
    this.unsubscribeComments()
  }

  addChannel() {
    this.firestoreDb.addChannel("test channel", "channelKey")
  }

  startListeningToComments(channelKey: string) {
    const db = this.firestoreDb.getApps()
    const queryConstraints = []
    queryConstraints.push(where("isEmpty", "==", false))
    queryConstraints.push(where("isDeleted", "==", false))
    queryConstraints.push(where("channelKey", "==", channelKey))
    if (this.unsubscribeComments) {
      this.unsubscribeComments()
    }
    const q = query(collection(db, "organizations", this.organizationKey, "content"), ...queryConstraints);
    let uC = onSnapshot(q, (snapshot) => {
      this.comments.splice(0, this.comments.length);
      snapshot.forEach((child) => {
        let content: any = child.get("content")
        let dateOfCreation = new Date(child.get("dateOfCreation")) 
        const dateOfUpdate = new Date(child.get("dateOfUpdate")) 
        let formattedDate = dateOfUpdate.toLocaleDateString("pl-PL") + " " + dateOfUpdate.toLocaleTimeString("pl-PL")
        let userId: any = child.get("userId")
        let userName: any = child.get("userName")
        let objectKey: any = child.get("canvasObjectKey")
        let objectType: any = child.get("canvasObjectType")
        const userImageURL = child.get("userImageURL")
        const parentCommentKey: any = child.get("parentCommentKey") || "  "
        let imageURLS: url[] = []
        let isDeleted = (child.get("isDeleted") == true)
        if (isDeleted == true) {
          content = "<p>(comment removed)</p>"
          imageURLS.splice(0, imageURLS.length)
        }
        let commentKey: string = child.id
        if (content != undefined) {
          this.comments.push({"key": commentKey, "content": content, "dateOfCreation": dateOfCreation, "dateOfUpdate": dateOfUpdate, "formattedDate": formattedDate, "userId": userId, "userName": userName, "imageURLS": imageURLS, "isDeleted": isDeleted, "canvasObjectKey": objectKey, "canvasObjectType": objectType, "userImageURL": userImageURL, "projectKey": this.projectKey, "parentCommentKey": parentCommentKey})
          let commentIndex = this.comments.length-1
          if (isDeleted == false) {
            this.firestoreDb.getImagesForComment(channelKey, commentKey, commentIndex).then((urls) => {
              urls.snapshot.forEach(url => {
                const storage = getStorage();
                const imageRef = refStorage(storage, url.get("url"));
                getDownloadURL(imageRef)
                  .then((u) => {
                    imageURLS.push({"url": u, "type": url.get("type"), "imageKey": url.id, "coverImageURL": "", "isChecked": false, "isAnalyzed": false}) // tu trzeba dorobić odczytywanie obrazka okładkowego
                    let comInd = this.getCommentByKey(commentKey)
                    if (comInd > -1) {
                      this.comments[comInd].imageURLS = imageURLS
                    }
                  })   
              })
            })
          }
        }
      });
      this.comments.sort(function (a, b) {
        return b.dateOfCreation.getTime() - a.dateOfCreation.getTime();
      })
      this.isLoadingLabelVisible = false
      this.commentUpdated.emit({comments: this.comments})
    });
    this.unsubscribeComments = uC;
  }

  getCommentByKey(commentKey: string) {
    for (let c = 0; c < this.comments.length; c++) {
      if (this.comments[c].key == commentKey) {
        return c
      }
    }
    return -1
  }


  outputEditedCommentKey(event: {"commentKey": string, "isAddEditorPresent": boolean}) { // fired when comment is edited
    this.editedCommentKey = event.commentKey
    this.isAddCommentEditorPresent = event.isAddEditorPresent
  //  if (this.editedCommentKey == "") {
      //let ind = this.getCommentByKey(commentKey)
     // this.isAddCommentEditorPresent = false
 //   }
  }

  showCommentEditor() {
    this.service.editedCommentKey = ""
  }

}
